<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0 ; height:auto !important">
           <div @click="jump()" style="width:100% ; height:100px ;background-color:#000;color:#fff">
            t4下一步t5
           </div>
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }
 

</style>
<script>
    import Vue from 'vue'; 
    import PicUploader from '@/components/picker/PicUploader.vue'; 

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
 

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader, 
        },
        data: function () {
            return {  
            }
        },
        filters: {},
        mounted() {
            let that = this; 
            document.title = 't-4'; 
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            jump(){
                rbLink({
                    name:'Tpage5'
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Tpage4.vue?6596a6f6